/**
 * Provider-neutral email message shape used by EmailService summaries.
 * @typedef {object} EmailMessageSummary
 * @property {string} [id]
 * @property {string} [from]
 * @property {string} [fromName]
 * @property {string} [subject]
 * @property {string} [snippet]
 * @property {number} [internalDate]
 */

/**
 * @typedef {object} EmailSummaryResult
 * @property {boolean} success
 * @property {string} message
 * @property {string} [code]
 * @property {number} [count]
 * @property {EmailMessageSummary[]} [messages]
 * @property {string} [providerId]
 */

/**
 * @typedef {object} EmailOpenResult
 * @property {boolean} success
 * @property {string} message
 * @property {string} [code]
 * @property {() => void} [performAction]
 * @property {string} [providerId]
 */

/**
 * @typedef {object} EmailProvider
 * @property {string} id
 * @property {string} label
 * @property {() => Promise<boolean>} isConnected
 * @property {(options?: { hours?: number }) => Promise<EmailSummaryResult>} summarizeRecent
 * @property {(options?: { hours?: number }) => Promise<EmailSummaryResult>} [reviewAllUnread]
 * @property {() => Promise<EmailSummaryResult>} [checkSpamAttention]
 * @property {() => Promise<EmailOpenResult>} openInbox
 * @property {() => Promise<EmailOpenResult>} [openSpam]
 */

export const EMAIL_NOT_CONNECTED_MESSAGE =
  "I don't have access to your email yet. Connect your Gmail account from Ashley Settings to enable email support.";

export const EMAIL_UNAVAILABLE_MESSAGE =
  "I couldn't reach your email right now. Please try again in a moment.";

export const EMAIL_OPENING_MESSAGE = "Opening your inbox.";

export const EMAIL_OPENING_SPAM_MESSAGE = "Opening your Spam folder.";